import { render, staticRenderFns } from "./create-company-document.vue?vue&type=template&id=4583d142&scoped=true&"
import script from "./create-company-document.vue?vue&type=script&lang=js&"
export * from "./create-company-document.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4583d142",
  null
  
)

export default component.exports